import { useCallback, useRef } from "react";
import useEvent from "../../hooks/useEvent";
import useModalEvent from "../../hooks/useModalEvent";
import { ImportLogOverlay } from "../../components/ImportLogOverlays/ImportLogOverlay";
import { useState } from "react";

export const ImportTaskTemplatesLogOverlay = () => {
  const overlayRef = useRef(null);
  const { Events, useRegisterCustomEvent } = useEvent();
  const { ModalEvents, toggleModal } = useModalEvent();
  const [taskTypeId, setTaskTypeId] = useState();

  const toggleOverlayEvent = useCallback(
    (e) => {
      if (!e?.detail?.taskTypeId)
        console.error(
          "The import log overlay was called without a task type ID"
        );

      setTaskTypeId(e.detail.taskTypeId);

      if (overlayRef.current) {
        overlayRef.current.show();
      }
    },
    [setTaskTypeId]
  );

  useRegisterCustomEvent(
    Events.TaskTemplatesImportLogOverlay,
    toggleOverlayEvent
  );

  return (
    <ImportLogOverlay
      id={"dd_task-templates-import-log-overlay"}
      ref={overlayRef}
      type="templates"
      taskTypeId={taskTypeId}
      onReview={({ Errors }) => {
        overlayRef.current?.hide();
        toggleModal(ModalEvents.ImportTemplates, {
          step: 2,
          errors: Errors,
          taskTypeId: taskTypeId
        });
      }}
      onNewImport={() => {
        overlayRef.current?.hide();
        toggleModal(ModalEvents.ImportTemplates, { taskTypeId: taskTypeId });
      }}
    />
  );
};
